import { Center, VStack } from '@chakra-ui/react'
import { AffiliateBanner } from './AffiliateBanner'
import { Spinner } from '@/components/atoms/Spinner'

interface AffiliateOverviewTabProps {
  account: any
  partnerData: any
  affiliateLink: string
  onCopy: (link: string) => void
  onConnectWallet: () => void
}

export const AffiliateOverviewTab = ({
  account,
  partnerData,
  affiliateLink,
  onCopy,
  onConnectWallet,
}: AffiliateOverviewTabProps) => {
  return (
    <VStack spacing={6} align="stretch">
      <AffiliateBanner
        account={account}
        affiliateLink={affiliateLink}
        onCopy={onCopy}
        onConnectWallet={onConnectWallet}
      />

      {!account ? (
        <></>
      ) : !partnerData ? (
        <Center py={12}>
          <Spinner h={24} />
        </Center>
      ) : (
        <></>
      )}
    </VStack>
  )
}
